// extracted by mini-css-extract-plugin
export default {"a":"index-module_a_9RF3q","img":"index-module_img_uYxNm"};